module.exports = __webpack_public_path__ + "static/media/close-x.644e4a72.svg";